export enum PurchaseRoutePathsEnum {
  PURCHASE_SUCCESSFUL = 'purchase-successful',
  PAYMENT_FAILED = 'payment-failed',
  OFFER = 'offer',
  OFFER_ACCEPTED = 'offer-accepted',
  OFFER_DECLINED = 'offer-declined',
  OFFER_RECREATED = 'offer-recreated',
  PURCHASE_DEVICE = 'purchase-device/:uuid',
}
